import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap/lib';
import { Confirm } from 'react-confirm-bootstrap';
import { Permissions } from '@upstart/harmony/lib/constants';
import withAnnouncementPermission from './announcementPermission';

function DeleteButton({ announcement, onDelete }) {
  return (
    <Confirm
      onConfirm={() => onDelete(announcement.id)}
      body={`Are you sure you want to delete "${announcement.title}"?`}
      confirmText="Confirm Delete"
      title={`Deleting "${announcement.title}"`}
    >
      <MenuItem>Delete</MenuItem>
    </Confirm>
  );
}

DeleteButton.propTypes = {
  announcement: PropTypes.object,
  onDelete: PropTypes.func,
};

export default withAnnouncementPermission(Permissions.DELETE)(DeleteButton);
